import { useMemo } from 'react';

import { PermissionType } from 'api/types/entity';
import { LinkField } from 'components';
import { generatePath, ROUTES } from 'libs/navigation';
import { usePermissions } from 'libs/permissions';
import { Input } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

export interface ClientFieldProps {
  label: string;
  clientName: string;
  clientId: string;
  clientType: 'person' | 'legal';
  disabled?: boolean;
}

export const ClientField = ({
  label,
  clientName,
  clientId,
  clientType,
  disabled,
}: ClientFieldProps) => {
  const { checkPermission } = usePermissions();

  const isAccess = useMemo(
    () => checkPermission(PermissionType.Client_LegalClient_GetOne),
    [checkPermission]
  );

  const link = useMemo(() => {
    if (clientType === 'person') {
      return generatePath(ROUTES.clients.personClients.personClient.fullPath, {
        clientId,
      });
    }
    return generatePath(ROUTES.clients.legalClients.legalClient.fullPath, {
      legalClientId: clientId,
    });
  }, [clientId, clientType]);

  if (!isAccess || disabled) {
    return (
      <Input
        readOnly
        showCopyButton
        disabled={disabled}
        label={label}
        value={clientName}
      />
    );
  }

  return (
    <LinkField Icon={Icon.User} label={label} link={link} value={clientName} />
  );
};
